"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeSelect = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const Select_1 = __importDefault(require("./Select"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
function RangeSelect(_a) {
    var { name, options = [], labels, value, onChange, shrink = [], label, labelIcon, endAdornment, background } = _a, rest = __rest(_a, ["name", "options", "labels", "value", "onChange", "shrink", "label", "labelIcon", "endAdornment", "background"]);
    return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, Object.assign({}, rest),
        label && (react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary", icon: labelIcon, marginBottom: "XS" }, label)),
        react_1.default.createElement(StyledRow, null,
            react_1.default.createElement(Select_1.default, { name: name, label: labels[0], value: value[0], onChange: ({ value: v }) => onChange({
                    name: name,
                    value: [v, value[1]]
                }), shrink: shrink[0], options: options[0], background: background }),
            react_1.default.createElement(Select_1.default, { name: name, label: labels[1], value: value[1], onChange: ({ value: v }) => onChange({
                    name: name,
                    value: [value[0], v]
                }), shrink: shrink[1], options: options[1], background: background }))));
}
exports.RangeSelect = RangeSelect;
const StyledRow = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Grid) `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1px;
  border-radius: 5px;
  overflow: hidden;
`;
//# sourceMappingURL=RangeSelect.js.map